import api from './api'

export const attributesService = {
  getByCategory: async (categoryId) => {
    const res = await api.get('/attributes', { params: { categoryId } })
    return res.data.data
  },

  create: async (data) => {
    const res = await api.post('/attributes', data)
    return res.data.data
  },

  update: async (id, data) => {
    const res = await api.patch(`/attributes/${id}`, data)
    return res.data.data
  },

  delete: async (id) => {
    await api.delete(`/attributes/${id}`)
  },

  getProductAttributes: async (productId) => {
    const res = await api.get(`/attributes/product/${productId}`)
    return res.data.data
  },

  updateProductAttributes: async (productId, data) => {
    const res = await api.put(`/attributes/product/${productId}`, data)
    return res.data.data
  },
}
